<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="width"
  >
    <path
      d="M8.68 5.516C8.44667 5.516 8.25067 5.44133 8.092 5.292C7.94267 5.13333 7.868 4.93733 7.868 4.704C7.868 4.48 7.94267 4.29333 8.092 4.144C8.25067 3.99467 8.44667 3.92 8.68 3.92C8.904 3.92 9.09533 3.99467 9.254 4.144C9.41267 4.29333 9.492 4.48 9.492 4.704C9.492 4.93733 9.41267 5.13333 9.254 5.292C9.09533 5.44133 8.904 5.516 8.68 5.516ZM8.092 14V7.056H9.268V14H8.092Z"
      :fill="fill"
    />
    <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" :stroke="stroke" />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 18,
  },
  height: {
    type: [String, Number],
    default: 18,
  },
  fill: {
    type: String,
    default: '#6CBD45',
  },
  stroke: {
    type: String,
    default: '#6CBD45',
  }
});
</script>